<template>
    <div class="editor-box padding-box" v-loading="loading">
        <el-scrollbar>
            <div style="width: 100%; overflow-x: auto;">
                <div
                    class="department-label"
                    :class="currDepartment == v.id ? 'selected-btn' : ''"
                    v-for="(v, i) in list" :key="v.id"
                    @click="changeDepart(v.id)"
                >
                    {{v.departmentname}}
                </div>

            </div>

            <div v-for="(item, index) in cardList" :key="item.id">
                <div v-if="item.defaulttag !== -2" class="department-div">
                    <UserSimpleInfo :showLocation="false" :obj="item" />

                    <el-button
                        type="primary"
                        plain
                        @click="clickEditBtn(item)"
                        size="small"
                        :color="'#32c5d2'"
                        class="icon-button"
                        style="margin-top: 15px"
                        v-if="userInfoRef.addinfo6 == -1"
                    >
                        <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                        &nbsp;
                        <span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span>
                    </el-button>
                </div>
            </div>

            <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="cardList.length === 0">

            </el-empty>
        </el-scrollbar>

        <el-dialog
            v-model="editVisible"
            :title="i18n.tkey('lang_edit_staff')"
            :width="myUtil.isMobile() ? '90%' : '600px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <companyStaffEditor
                :editLogin="editLogin"
                @save-complete="saveCallback"
            />
        </el-dialog>
    </div>
</template>

<script setup>

import UserSimpleInfo from "@/components/shopopee/user/userSimpleInfo.vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {inject, ref, toRef, onBeforeMount, provide} from "vue";
import myUtil from "@/util/util";
import CompanyStaffEditor from "@/components/shopopee/company/companyStaffEditor.vue";
import {useUserinfo} from "@/stores/userinfo";
import cardApi from "@/request/api";
import { faChevronLeft,faPenToSquare } from '@fortawesome/free-solid-svg-icons'
library.add(faChevronLeft,faPenToSquare)

const props = defineProps(["list", "companycode"])
const emits = defineEmits(["save-complete"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const editVisible = ref(false)
const editLogin = ref(null)

const currDepartment = ref(null)
const loading = ref(false)
const cardList = ref([])
const currCard = ref(null)

function clickEditBtn(obj){
    currCard.value = obj
    editLogin.value = obj.login
    editVisible.value = true
}

function saveCallback(){
    getDepartCard()
    emits("save-complete")
}

function changeDepart(id){
    currDepartment.value = id

    getDepartCard()
}

function getDepartCard(){
    loading.value = true

    const request = cardApi.queryDepartCardList
    const params = request.getParams()

    params.department = currDepartment.value

    if (null != props.companycode){
        params.companycode = props.companycode
    }else{
        params.companycode = userInfoRef.value.companycode
    }

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            cardList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function getCurrCard(){
    return currCard.value
}

provide('myCardViewFunc', {
    getCurrCard,
})

defineExpose({
    getDepartCard
})

onBeforeMount(() => {
    if (null != props.list && props.list.length > 0){
        currDepartment.value = props.list[0].id
        cardList.value = props.list[0].memberworkList
    }
})

</script>

<style scoped>

.editor-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
}

.padding-box {
    padding: 10px;
    box-sizing: border-box;
}

.department-label {
    font-size: 16px;
    font-weight: 600;
    line-height: 2;
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;
}

.department-div {
    padding-bottom: 10px;
    margin-top: 10px;
    box-sizing: border-box;
    border-bottom: 1px #EBEEF5 solid;
}

.selected-btn {
    color: #F56C6C;
}

</style>